import { useParams } from 'react-router-dom';
import useFormularioCanteiroAreia from '../../hooks/useFormularioCanteiroAreia';
import FormularioCanteiroAreiaHeader from './FormularioCanteiroAreiaHeader/FormularioCanteiroAreiaHeader';
import FormularioCanteiroAreiaAnalise from './FormularioCanteiroAreiaAnalise/FormularioCanteiroAreiaAnalise';
import Header from '../../../../../components/Header/Header';
import PageTitle from '../../../../../components/PageTitle/PageTitle';
import ModalConfirmacao from '../Modais/ModalConfirmacao';
import ModalDecisao from '../Modais/ModalDecisao';

export default function FormularioCanteiroAreiaPage() {
  const { id } = useParams<{ id: string }>();
  const {
    detalhes, loading, error, analise, imagens, analistas, searchAnalistas, refetch,
  } = useFormularioCanteiroAreia(id || '');

  const dadosAnalise = analise.dadosAnalise || detalhes?.dadosAnalise;
  const isVisible = !loading && !error && !detalhes;

  return (
    <div className="lista-sementes-page">
      <Header>
        <PageTitle
          breadcrumbs={[
            {
              label: 'Laboratório de Sementes',
              url: '/sementes',
            },
            {
              label: 'Canteiro de Areia',
            },
          ]}
        />
      </Header>

      {loading && <div>Carregando...</div>}
      {error && <div>Erro: {error}</div>}
      {isVisible && <div>Análise não encontrada</div>}

      {detalhes && (
        <>
          <FormularioCanteiroAreiaHeader
            produtor={detalhes.produtor}
            idDaAmostra={detalhes.nAmostra}
            numeroRemessa={detalhes.numeroRemessa}
            especie={detalhes.especie}
            lote={detalhes.lote}
            safra={detalhes.safra}
            nomeCientifico={detalhes.nomeCientifico}
            cultivar={detalhes.cultivar}
            categoria={detalhes.categoria}
            dataEntrada={detalhes.dataEntrada}
            dataAmostragem={detalhes.dataAmostragem}
            status={detalhes.status}
            imagens={imagens.imagens}
            onAdicionarImagem={imagens.adicionarImagem}
            onRemoverImagem={imagens.removerImagem}
            loadingImagens={imagens.loading}
          />

          <FormularioCanteiroAreiaAnalise
            analistas={analistas}
            searchAnalistas={searchAnalistas}
            onSubmit={(formId, dados, concluir) => analise.submitAnalise(
              formId,
              dados,
              detalhes.nAmostra,
              refetch,
              concluir,
            )}
            loading={analise.loading}
            initialValues={dadosAnalise}
            disabled={detalhes.concluidoApi || false}
          />

          <ModalDecisao
            visible={analise.modalConfirmarConclusaoVisible}
            title="Concluir análise?"
            description={`Deseja concluir a análise de canteiro de areia da amostra (Nº ${analise.nAmostraAtual})? O status da análise mudará para REALIZADO.`}
            okButtonLabel="Confirmar"
            cancelButtonLabel="Fechar"
            onConfirm={analise.confirmarConclusao}
            onCancel={analise.cancelarConclusao}
          />

          <ModalConfirmacao
            visible={analise.modalAnaliseConcluidaVisible}
            title="Análise concluída"
            description={`A análise de canteiro de areia da amostra (Nº ${analise.nAmostraAtual}) foi concluída e seu status mudou para REALIZADO`}
            onConfirm={analise.fecharModalAnaliseConcluida}
            buttonLabel="Ok"
          />
        </>
      )}
    </div>
  );
}
